import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import AIGeneratedQuestions from 'relevant-items/AIGeneratedQuestions';
import RelevantItemsSection from 'relevant-items/RelevantItemsSection';

interface Props {
  fileId: string;
  fileName: string;
}

export default function RelevantItemsView(props: Props): JSX.Element {
  return (
    <div className="react-tab-container">
      {BenchlingConfig.LLM_AI_RELEVANT_ITEMS_SUGGESTED_QUESTIONS &&
        BenchlingConfig.LLM_ENABLE_AI_DEEP_RESEARCH && (
          <AIGeneratedQuestions fileId={props.fileId} fileName={props.fileName} />
        )}
      <RelevantItemsSection fileId={props.fileId} />
    </div>
  );
}
